var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bean-source-page',{attrs:{"type":_vm.type,"columns":_vm.columns,"filter-columns":_vm.filterColumns,"actions":_vm.actions,"title":_vm.$t('model.passenger'),"resource":"passengers"}})
}
var staticRenderFns = []

export { render, staticRenderFns }